import { GET_API, POST_API } from "../../../Functionalities/APIs";

const SEARCH_PATH = "/items/categories/search/";
const MENU_PATH = "/items/innercategory/";
const UNREACHABLE = "Could not reach the server. Try again.";

export const searchCategoryName = async (name) => {
  const result = await GET_API("", `name=${encodeURIComponent(name)}`, SEARCH_PATH);
  const reply = result && result.data;
  if (!reply) return { error: UNREACHABLE };
  if (!reply.Status) return { error: reply.Error || reply.Message || UNREACHABLE };
  const { kind, umbrella, close, existing } = reply;
  return { kind, umbrella, close, existing };
};

export const addMenuCategory = async ({ name, confirmNew = false }) => {
  const form = new FormData();
  form.append("name", name);
  form.append("is_active", 1);
  form.append("is_blocked", false);
  form.append("inner_category", true);
  if (confirmNew) form.append("confirm_new", "true");
  const result = await POST_API(form, "", MENU_PATH);
  const reply = result && result.data;
  if (!reply) return { error: UNREACHABLE };
  return reply.Status ? { ok: true } : { error: reply.Error || reply.Message || UNREACHABLE };
};
